<template>
  <div class="news-list-page">
    <div class="container">
      <ul class="filter">
        <li class="item" v-for="(item, index) in filter" :key="index">
          <span @click="filterItems(item, index)" :class="{ active: item.isActive }">{{
            item.name
          }}</span>
        </li>
      </ul>
      <div class="row">
        <div class="col-sm-6 col-md-4 col-lg-3 item"
          v-for="(item, index) in showingNewsList"
          :key="index"
          @click.prevent="changePath(item.newsId)"
          >
          <NewsItem :news="item"></NewsItem>
        </div>
      </div>
      <Pagination :page="page" :length="totalPage" @changePage="changePage"></Pagination>
    </div>
  </div>
</template>

<script>
import NewsItem from './NewsItem.vue'
import Pagination from './Pagination.vue'

import newsData from '../../json/news/news.js'
export default {
  components: {
    NewsItem,
    Pagination
  },
  data () {
    return {
      filter: [],
      itemPerPage: 4,
      pagination: [],
      setting: {},
      newsList: [],
      tempNewsList: [],
      showingNewsList: [],
      totalNews: 0,
      page: 1
    }
  },
  props: ['filterProp'],
  created () {
    this.filter = this.filterProp
    this.init()
  },
  methods: {
    init: function () {
      if (window.innerWidth > 768) {
        this.itemPerPage = 12
      } else if (window.innerWidth > 575) {
        this.itemPerPage = 8
      } else {
        this.itemPerPage = 4
      }

      this.newsList = newsData.getNewsList()
      this.tempNewsList = this.newsList
      this.totalNews = this.tempNewsList.length
      this.customizeNewsList(0)
    },
    changePath: function (path) {
      window.location.href = `/GiftEd/${this.$route.params.lang}/news/${path}`
    },
    changePage: function (page) {
      this.page = page
      this.customizeNewsList(page - 1)
    },
    customizeNewsList: function (page) {
      var lastSlice = this.itemPerPage * (page + 1) < this.totalNews ? this.itemPerPage * (page + 1) : this.totalNews
      var tempArray = this.tempNewsList.slice(this.itemPerPage * page, lastSlice)
      var filterType = this.getFilterType()

      if (filterType === 'all') {
        this.showingNewsList = tempArray
      } else {
        this.showingNewsList = tempArray.filter((news) => {
          return news.data === filterType
        })
      }
    },
    getFilterType: function () {
      return this.filter.find(el => el.isActive === true).data
    },
    filterItems: function (item, index) {
      this.filter.map(el => {
        el.isActive = false
      })
      this.filter[index].isActive = true

      this.page = 1
      if (item.data === 'all') {
        this.tempNewsList = this.newsList
        this.totalNews = this.tempNewsList.length
      } else {
        this.tempNewsList = this.newsList.filter((news) => {
          return news.data === item.data
        })
        this.totalNews = this.tempNewsList.length
      }
      this.customizeNewsList(0)
    }
  },
  computed: {
    totalPage: function () {
      return Math.ceil(this.totalNews / this.itemPerPage)
    }
  }
}
</script>

<style scoped>
@import url("../../../static/css/news-style/news.css");
</style>



// WEBPACK FOOTER //
// src/components/News/NewsList.vue